import { render, staticRenderFns } from "./UserCustomerModal.vue?vue&type=template&id=612972eb&scoped=true&"
import script from "./UserCustomerModal.vue?vue&type=script&lang=js&"
export * from "./UserCustomerModal.vue?vue&type=script&lang=js&"
import style0 from "./UserCustomerModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserCustomerModal.vue?vue&type=style&index=1&id=612972eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612972eb",
  null
  
)

export default component.exports